import { render, staticRenderFns } from "./batteryDialog.vue?vue&type=template&id=65d5f0ce&scoped=true&"
import script from "./batteryDialog.vue?vue&type=script&lang=js&"
export * from "./batteryDialog.vue?vue&type=script&lang=js&"
import style0 from "./batteryDialog.vue?vue&type=style&index=0&id=65d5f0ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d5f0ce",
  null
  
)

export default component.exports